export const site = {
  brand: "nguie.ops",
  initial: "N",
  name: "Jean Roch Junior Nguie Angoue",
  shortName: "Jean",
  tagline: "I AUTOMATE\nTHE CHAOS.",
  years: "6+",
  email: "nguierochjunior@gmail.com",
  phone: "+241 74-66-11-00",
  location: "Libreville, Gabon",
  github: "https://github.com/nguie2",
  linkedin: "https://www.linkedin.com/in/nguie-angoue-j-2b2880254/",
  twitter: "https://x.com/jean32529",
  resumePath: "/resume.pdf",
  footer: "© 2026 Jean Roch Junior. Built with uptime in mind.",
};

export const navLinks = [
  { href: "#about", label: "About" },
  { href: "#skills", label: "Skills" },
  { href: "#work", label: "My Work" },
  { href: "#contact", label: "Contact" },
];

export const skills = [
  {
    name: "Docker",
    color: "bg-periwinkle",
    description: "Containerizing services for consistent, portable deployments.",
    icon: "docker",
  },
  {
    name: "Kubernetes",
    color: "bg-yellow",
    description: "Orchestrating clusters that scale and self-heal under load.",
    icon: "kubernetes",
  },
  {
    name: "AWS",
    color: "bg-pink",
    description: "Designing cost-efficient, secure cloud architecture at scale.",
    icon: "aws",
    iconLight: true,
  },
  {
    name: "Terraform",
    color: "bg-teal",
    description: "Infrastructure as code, versioned and repeatable everywhere.",
    icon: "terraform",
    iconLight: true,
  },
  {
    name: "CI/CD",
    color: "bg-yellow",
    description: "Automated pipelines that ship code from commit to prod.",
    icon: "cicd",
  },
  {
    name: "Monitoring",
    color: "bg-periwinkle",
    description: "Prometheus, Grafana & alerting that catches issues first.",
    icon: "monitoring",
  },
  {
    name: "Linux",
    color: "bg-pink",
    description: "Deep systems knowledge across Debian, RHEL & Alpine.",
    icon: "linux",
    iconLight: true,
  },
  {
    name: "Ansible",
    color: "bg-teal",
    description: "Config management that keeps every server in sync.",
    icon: "ansible",
    iconLight: true,
  },
];

export const aboutStats = [
  { value: "6+", label: "years in DevOps & SRE" },
  { value: "55%", label: "infra cost reduction delivered" },
  { value: "99.9%", label: "average uptime delivered" },
];

export const experience = [
  {
    period: "2024 to Now",
    title: "DevOps Engineer / SRE Consultant",
    company: "Dzoshift",
    description:
      "Led GitOps CI/CD with ArgoCD, multi-region cloud migrations, and observability platforms that cut MTTR by 65%.",
    dotColor: "bg-yellow",
  },
  {
    period: "2022 to 2024",
    title: "Senior DevOps Engineer / SRE Lead",
    company: "OriginFintech",
    description:
      "Architected multi-cluster Kubernetes on AWS, cut infra costs 55%, and reduced production incidents by 85%.",
    dotColor: "bg-teal",
  },
  {
    period: "2019 to 2022",
    title: "DevOps Engineer",
    company: "JJTech Inc",
    description:
      "Built CI/CD from scratch with Jenkins & IaC, established Prometheus/Grafana monitoring, and cut deploy time 80%.",
    dotColor: "bg-pink",
  },
];

export const projects = [
  {
    title: "GitOps Express Cluster",
    description:
      "Zero-trust K8s cluster with ArgoCD, Cilium CNI, and Grafana Loki. Self-healing via Prometheus alerts.",
    color: "bg-yellow",
    icon: "kubernetes",
    href: "https://github.com/nguie2/gitops-express-cluster",
  },
  {
    title: "Real-time Vision API",
    description:
      "Production computer vision with YOLOv9, MLOps pipeline, drift detection, and continuous learning on Kubernetes.",
    color: "bg-periwinkle",
    icon: "monitoring",
    href: "https://github.com/nguie2/real-time-vision-api",
  },
  {
    title: "Multi-Cloud K8s Platform",
    description:
      "Identical EKS/AKS/GKE clusters with cross-cloud networking, VictoriaMetrics, and Velero disaster recovery.",
    color: "bg-pink",
    icon: "terraform",
    href: "https://github.com/nguie2/terraform-multicloud-eks-aks-gke",
    iconLight: true,
  },
];

export const testimonials = [
  {
    quote:
      "Jean's infrastructure optimization initiatives resulted in 55% cost reduction while improving reliability. His expertise in multi-cloud environments is exceptional.",
    name: "Camilla Buys",
    role: "CTO, OriginFintech",
    color: "bg-yellow",
    textDark: true,
  },
  {
    quote:
      "Our on-call rotation went from dreaded to boring. That's the highest compliment I can give a DevOps engineer.",
    name: "Emmanuel Sarpong-Oduro",
    role: "Managing Director, MDP Ghana",
    color: "bg-periwinkle",
    textDark: true,
  },
  {
    quote:
      "Sharp, calm under pressure, and genuinely great at explaining infra and AI systems to non-technical stakeholders.",
    name: "Dzoshift Team",
    role: "Enterprise Client, Gabon",
    color: "bg-pink",
    textDark: false,
  },
];
